import { render, staticRenderFns } from "./OutcomeChip.vue?vue&type=template&id=24efdc1a"
import script from "./OutcomeChip.vue?vue&type=script&lang=js"
export * from "./OutcomeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports